<template>
  <div class="CalculatedHeaderBox">
    <div class="footerHeader">
      <img class="img" src="@/assets/images/ceyiceicon.png" alt="" />
      <p class="titleText">
        额度测算中...
      </p>
      <p class="text">
        {{ text }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalculatedHeader',
  props: {
    text: String,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.footerHeader {
  display: flex;
  width: 100%;
  height: 150px;
  background: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footerHeader .img {
  width: 40px;
  height: 40px;
  margin-top: 40px;
}
.footerHeader .titleText {
  font-size: 17px;
  margin: 10px 0 12px 0;
  font-weight: bold;
}
.footerHeader .text {
  font-size: 12px;
  color: #8d8d8d;
  font-family: PingFangSC-Regular;
  font-weight: bold;
}
p {
  margin: 0;
}
</style>
